import React from 'react';

export default class Container extends React.Component
{
    render()
    {
        return <div className='overflow-y-auto w-full'>
            <div className="my-8 mx-auto px-4 sm:px-6 lg:px-8 sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl">
                <div className="mx-auto space-y-8">
                    {this.props.children}
                </div>
            </div>
        </div>;
    }
}
